import React, { useState, useEffect, useRef } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'

import './styles.scss'
import { Map } from 'components/map'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Slider } from 'components/slider'
import Scrollchor from 'react-scrollchor'
import { cantons } from '../../cantons.js'
import { Link } from '@ta-interaktiv/contentbricks'

import * as d3 from 'd3'
import { ExtendedFeatureCollection, ExtendedFeature } from 'd3'
import { feature } from 'topojson-client'

const communesTopojson: ExtendedFeatureCollection = require('../map/communes.json')
const communesTopo = feature(
  communesTopojson,
  communesTopojson.objects.communes_epsg4326
)

const ARTICLE_ID = '770431470388'

export function AppComponent() {
  const destinations = [
    {
      id: 0,
      country: 'Pérou',
      commune: 'Zermatt',
      canton: 'Valais',
      name: 'Cuzco',
      text:
        "<p>Comme dans les Andes, la région de Zermatt est le lieu où l’on peut admirer des dizaines de sommets de plus 4000 mètres. Cuzco (Pérou) est perché à 3400m d’altitude, et la moyenne d'altitude de la commune de Zermatt est de 2900m. La durée de l’ensoleillement y est similaire, tout comme la température maximale (18-20°C). Certes, c’est un peu la loterie pour voir le Cervin sans qu’il se cache dans les nuages, mais il faut l’avoir vu, comme le Machu Picchu qu’on admire depuis Cuzco. Ici, pas de lamas. Ce sont les moutons nez noir qui habitent au pied de la montagne magique et acceptent gentiment de rencontrer les visiteurs <a href='https://www.zermatt.ch/fr/Media/Billets/Mise-en-beaute-des-moutons-a-nez-noir' class='cbLink cB' style='white-space: nowrap;' target='_blank' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>pour leur toilette</a> ou <a href='https://www.julen.ch/fr/evenements/randonnee-moutons/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>l’apéro</a>.</p><p>Les plus courageux profiteront de conquérir <a href='https://www.zermatt.ch/fr/randa/Dom-4000er-Weisshorn/Sommets-de-quatre-mille-metres-accessibles-depuis-Randa' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>leur premier sommet</a> de plus de 4000 m (uniquement en compagnie d’un guide), comme l’Allalinhorn ou le Breithorn.</p><p>En montant au Gornergrat, <a href='https://gornergrat-kulm.ch/fr/home-fr/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>l’hôtel le plus élevé d’Europe</a> permet de passer la nuit la tête dans les étoiles. Et, comme Zermatt est cosmopolite, les adeptes du ceviche trouveront leur bonheur au restaurant péruvien qui se cache dans le fameux Schweizerhof.<p>",
      weatherData: [20, 235, 3, 0.75, 2, 45, 3399],
    },
    {
      id: 1,
      country: 'Vietnam',
      commune: 'Weesen',
      canton: 'Saint-Gall',
      name: 'Hanoï',
      text:
        "<p>Les deux régions ont un point commun en été: la pluie. Puisque c’est la mousson au nord du Vietnam, il y pleut en moyenne seize jours par mois d’été. Le district de See-Gaster, dans le canton de Saint-Gall, comptabilise lui quatorze jours de pluie par mois d’été en moyenne.</p><p>Alors qu’Hanoï peut se vanter de sa cité impériale de Thang Long, classée au patrimoine mondial de l’Unesco, Saint-Gall, elle, est fière de sa bibliothèque abbatiale, également inscrite au patrimoine de l’Unesco. Toutes deux ont joué un rôle important en tant que villes marchandes, au Vietnam pour la riziculture, à Saint-Gall pour l’industrie textile.</p><p>En été, la <a href='https://www.myswitzerland.com/fr-ch/decouvrir/drei-weieren-trois-etangs/' class='cbLink cB' style='white-space: nowrap;' target='_blank' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>baignade aux 3 Étangs</a> (3 Weieren) est un must. Les maisonnettes qui les entourent ont des airs de pagodes vietnamiennes. Au bord du lac de Walenstadt, il est possible de manger le poisson <a href='https://www.myswitzerland.com/fr-ch/decouvrir/pecher-son-repas-de-midi-dans-le-lac-de-walen/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>pêché soi-même</a> et cuisiné par un chef. Au Vietnam, le vélo est très utilisé pour transporter des marchandises. Depuis Weesen, on peut s’amuser avec des <a href='https://www.myswitzerland.com/fr-ch/decouvrir/route/amden-bike/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>vélos bien équipés</a>, sans pour autant trop les charger.</p><p>Si la viande joue un important rôle dans la soupe «pho», dans la région de Saint-Gall, c’est la <a href='https://st.gallen-bodensee.ch/fr/experiences/shopping/gourmandises-culinaires-et-gastronomie.html' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>saucisse à rôtir</a> qui domine. Alors qu’Hanoï est considérée comme offrant un des plus larges choix de bières en Asie, Saint-Gall abrite, quant à elle, la plus ancienne <a href='https://www.myswitzerland.com/fr-ch/decouvrir/brasserie-schuetzengarten-et-son-musee/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>brasserie</a> de Suisse, ainsi que le premier musée de bouteilles de bière du pays. Et pour les nostalgiques des spécialités vietnamiennes, une adresse à Saint-Gall: le <a href='http://lansin.ch/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>restaurant Lansin</a>.</p>",
      weatherData: [32, 162, 16, 275, 3, 80, 32],
    },
    {
      id: 2,
      country: 'États-Unis',
      commune: 'Sion',
      canton: 'Valais',
      name: 'Las Vegas',
      text:
        "<p>Entre la capitale mondiale du jeu située en plein désert et les deux bourgades valaisannes, la ressemblance n’est pas frappante de prime abord. C’est néanmoins l’ensoleillement qui les relie, puisque Sion porte fièrement le titre de ville la plus ensoleillée de Suisse. Alors qu’à Las Vegas les grands hôtels veillent sur la métropole, à Sion ce sont les deux châteaux de Valère et de Tourbillon qui protègent la ville. Enfin, au cours de leur histoire, toutes deux ont dû trouver des solutions pour obtenir de l’eau, comme le témoigne la création des bisses, construits pour l’irrigation des vignes et des champs de cette vallée.</p><p>À Veysonnaz, l’hôtel <a href='http://www.veysonnaz.ch/fr/fppoi-hotel-chalet-royal-41081-13876.html' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Chalet Royal</a> a de quoi rivaliser avec les hôtels du Strip, notamment grâce à son panorama époustouflant et son jacuzzi extérieur.</p><p>À défaut de gagner au casino, il est possible de trouver un trésor le long du <a href='http://www.veysonnaz.ch/fr/fppoi-chasse-aux-tresors-sur-le-bisse-41595.html' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>bisse de Vex</a>.</p><p>Un peu en dessus de Sion, l’occasion d’admirer une merveille de la nature, non pas le Grand Canyon, mais les <a href='https://www.myswitzerland.com/fr-ch/decouvrir/route/euseigne-heremence-veysonnaz/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>pyramides d’Euseigne</a>.</p><p>D’apparence extérieure clinquante, <a href='https://www.celliers.ch/page/34-sur-les-pas-du-dahu' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>les Celliers de Sion</a> sont un centre dédié à l’œnotourisme où l’on peut découvrir les vins sous toutes leurs formes, en se promenant à pied ou à vélo, et même en faisant un escape game.</p><p>L’oasis de divertissement de la région est bien le <a href='https://les-iles.bourgeoisie-de-sion.ch/fr/accueil/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Domaine des Îles</a> à Sion, un lieu qui s’étend sur plus de 54 hectares, propice aux loisirs entre amis ou en famille (mur de grimpe, parc aventure, minigolf, etc). Et pour les grandes chaleurs, rien de mieux que de faire une excursion au <a href='https://www.lac-souterrain.com/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>lac souterrain</a> de Saint-Léonard.</p>",
      weatherData: [40, 390, 2, 8, 5, 20, 610],
    },
    {
      id: 3,
      country: 'Norvège',
      commune: 'Weinland',
      canton: 'Zurich',
      name: 'Oslo',
      text:
        "<p>Le climat d’Oslo, en Norvège, a un climat correspondant tout au nord du canton de Zurich. Non loin de Winterthour et de Frauenfeld, on tombe au cœur du Weinland zurichois, dans les villages de Thalheim an der Thur, Adlikon ou Humlikon. Tous les paramètres météo des deux régions se ressemblent, sauf l’altitude, car Oslo est au bord de la mer. La température maximale moyenne en été est de 22°C. Les jours de beau temps sont un peu plus nombreux dans le Weinland, mais les précipitations y sont plus importantes. Cela n’empêche pas la région d’avoir de beaux étés. Pour des vacances au goût historique, mais sans Vikings, un lieu hors du temps vous attend dans un environnement bucolique: la chartreuse d’Ittingen, qui date du XIIe siècle. Un hôtel (avec une chambre en bulle transparente) et un <a href='https://www.kartause.ch/en' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>musée d’art</a> vous accueillent dans ce lieu propice au ressourcement. Comme Oslo, sise à proximité de très belles forêts, la bucolique Thurgovie se découvre depuis <a href='https://www.myswitzerland.com/fr-ch/destinations/frauenfeld/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Frauenfeld</a> en partant à vélo ou à pied le long de multiples itinéraires.</p><p>À Winterthour, où l’on fait, comme à Oslo, la tournée de quelques beaux musées d’art, comme la Collection <a href='https://www.roemerholz.ch/sor/fr/home.html' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Oskar Reinhart</a>, qui, même si elle n’inclut pas «Le cri», d’Edvard Munch, présente plus de 200 œuvres d’art, notamment signées Monet, Manet ou Renoir. À Winterthour, on essaie aussi de comprendre et de jouer avec la technologie et les lois de la physique au <a href='https://www.technorama.ch/fr/home' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Technorama</a>, un musée totalement interactif: un peu comme au Musée des sciences et de la technologie d’Oslo. Finalement, comme il fallait bien du poisson au menu – le saumon est le poisson roi en Norvège -, on va goûter au <a href='https://www.restaurant-eichmuehle.ch/cordon-bleu-045-fisch-cordon-bleu.htm' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>cordon-bleu de saumon</a> du restaurant Eichmühle près de Winterthour, qui est le spécialiste du cordon-bleu (plus de 50 propositions, dont deux végétariennes).</p>",
      weatherData: [22, 215, 14, 78, 2.35, 65, 23],
    },
    {
      id: 4,
      country: 'Irlande',
      commune: 'Seeland',
      canton: 'Pays des Trois-lacs',
      name: 'Galway',
      text:
        "<p>Quatrième ville d’Irlande par sa taille, Galway est située sur la côte ouest du pays. L’eau, de même que dans le Seeland, «le pays des lacs» qui s’étend au sud-est du pied du Jura et comprend les trois lacs de Neuchâtel, Morat et Bienne - y joue un rôle prépondérant. Il y a de cela longtemps, ce territoire marécageux était la plaine d’inondation de l’Aar. Galway elle aussi, est traversée par la rivière Corrib (en irlandais Gaillimh), qui a donné son nom à la ville. Comme on ferait une croisière sur la rivière Corrib, on peut remonter le cours de <a href='https://www.myswitzerland.com/fr-ch/decouvrir/croisiere-sur-laar/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>l’Aar</a> dans le Seeland. Et naviguer aussi sur <a href='https://www.lacdebienne.ch/fr/horaire.2804.html' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>les lacs</a>. Reprise de la navigation prévue le 8 juin 2020. L’Aar se parcourt aussi <a href='https://www.j3l.ch/fr/V2086/aar-canoe' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>en canoë</a>.</p><p>Comme Galway, ville côtière où la pêche a joué un rôle extrêmement important, le Seeland est aussi une région de pêche, où l’on peut soi-même attraper des poissons ou accompagner les pêcheurs. Galway et ses environs sont connus comme un paradis pour les sports aquatiques et de plein-air. En cela, <a href='https://www.j3l.ch/fr/V1934/chemin-seeland-soleure' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>le Seeland</a>, avec ses plages, ses lacs, ses sentiers de randonnée et de vélo, n’a pas grand-chose à envier à sa jumelle climatique.</p><p>À pied, le <a href='https://www.schweizmobil.ch/fr/suisse-a-pied/itineraires/etappe-01591.html?nopager' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>chemin du Seeland</a>, en route pour <a href='https://www.j3l.ch/fr/V1975/chemin-ile-st-pierre' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>l’île Saint-Pierre</a> (lac de Bienne), <a href='https://www.j3l.ch/fr/V2390/ins-morat' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>à vélo</a>, en <a href='https://www.j3l.ch/fr/P36183/stand-up-paddling' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>stand up paddling</a> sur le lac de Bienne (depuis Nidau, p.ex.), <a href='https://www.schweizmobil.ch/fr/suisse-en-canoe/itineraires/itineraires-regionaux/route-080.html' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>en canoë</a>, sur le lac de Bienne: Au large de Galway, ce sont sept îles qu’il est possible de visiter, dont les îles d’Aran. La perle insulaire du Seeland est sans conteste <a href='https://www.j3l.ch/fr/P35710/l-ile-st-pierre' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>l’île Saint-Pierre</a> facilement accessible en bateau, à pied ou à vélo.</p>",
      weatherData: [18, 125, 25, 80, 4, 80, 25],
    },
    {
      id: 5,
      country: 'Thaïlande',
      commune: 'Bauen',
      canton: 'Uri',
      name: 'Phuket',
      text:
        "<p>Plusieurs communes des bords du fameux lac ont une météo douce semblable à celle de Phuket: l’ensoleillement et l’humidité y sont comparables, avec quelques degrés de moins chez nous. Seelisberg et son <a href='https://www.myswitzerland.com/fr-ch/destinations/lac-de-seelisberg/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>petit lac</a> aux eaux claires approchant les 24°C en été, ses falaises verdoyantes, sa petite plage ombragée et ses roseaux ont quelques points communs avec la Thaïlande, mais en plus calme. On y trouve la plus petite des <a href='https://www.youthhostel.ch/fr/auberges/seelisberg/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>auberges de jeunesse</a> de Suisse, qui a presque des airs de bungalow thaïlandais.</p><p>C’est aussi ici que se trouve la prairie du <a href='https://www.myswitzerland.com/fr-ch/destinations/gruetli-prairie-du-gruetli/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Grütli</a>, <a href='https://www.myswitzerland.com/fr-ch/decouvrir/route/le-berceau-de-la-confederation-helvetique/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>berceau de la Confédération helvétique</a>, à découvrir en se promenant ou en bateau. Presque comme dans une mangrove, il est possible de s’adonner à la <a href='https://www.erlebnisregion-mythen.ch/en/experiences/summer/adventures-in-and-on-the-water/brunnen-canoe-station/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>pratique du canöe</a> depuis Brunnen.</p><p>Une autre tradition de cette région, surnommée la <a href='https://www.swissknifevalley.ch/fr/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Swiss Knife Valley</a>, est bien entendu le célèbre couteau Victorinox. Un musée lui est dédié. À Bauen, village idyllique répertorié par l’Inventaire fédéral des sites construits d’importance nationale à protéger en Suisse, le climat est si doux qu’on peut y cultiver bananes, figues, abricots, kakis, kiwis et autres plantes exotiques.</p>",
      weatherData: [32, 150, 21, 200, 1, 78, 529],
    },
    {
      id: 6,
      country: 'Japon',
      commune: 'Emmental',
      canton: 'Berne',
      name: 'Tokyo',
      text:
        "<p>Les conditions de pluie, d’humidité et de vent sont quasi identiques au Japon et dans l'Emmental pendant l’été. Mais à 900m d’altitude, la température maximale moyenne de Langnau (21°C) ne peut pas rivaliser avec celle de Tokyo (28°C).</p><p>En raison de ses nombreuses collines, la région se prête parfaitement à la <a href='https://www.flyer-bikes.com/fr-fr/portrait-de-lentreprise' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>pratique du vélo électrique</a>. Et c’est d’ailleurs à Kirchberg que naissait le premier vélo électrique il y a vingt-cinq ans.</p><p>Sur un ou deux jours, la <a href='https://www.bern.com/fr/detail/la-route-du-fromage-de-la-vallee-de-lemmental' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>route du fromage</a> permet de suivre un itinéraire pour deux-roues à travers la vallée de l’Emmental. Pour découvrir le fameux Emmentaler, la <a href='https://www.myswitzerland.com/fr-ch/decouvrir/fromagerie-de-lemmentaler-aop/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>fromagerie d’Affoltern</a> propose des dégustations. La gastronomie ne se limite néanmoins pas au fromage, car l’un des plus <a href='https://www.myswitzerland.com/fr-ch/planification/vie-pratique/organisation/kambly-sa-specialites-de-biscuits-suisses/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>célèbres biscuits</a> du pays est originaire de la fabrique Kambly, à Trubschachen, où l’on peut déguster le fameux «Bretzeli».</p><p>À travers Eggiwil, un <a href='https://www.myswitzerland.com/fr-ch/decouvrir/le-sentier-des-maisons-drsquoeggiwil/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>sentier thématique</a> permet de découvrir les maisons traditionnelles de la région, des chalets en bois aux toits descendant très bas, avec des balcons fleuris et des petits jardins.</p><p>À Berthoud (Burgdorf en allemand), une <a href='https://www.youthhostel.ch/fr/auberges/berthoud/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>nouvelle auberge de jeunesse</a> ouvrira ses portes mi-juin au sein du château, une bâtisse historique de plus de 900 ans, qui comporte également un musée et un restaurant. Le paradis de la randonnée est à quelques pas. Il s’agit du parc <a href='https://www.parks.swiss/fr/les_parcs_suisses/portraits_des_parcs/unesco_biosphere_entlebuch.php' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Unesco Biosphäre Entlebuch</a>, aussi surnommé le Far West de Lucerne, où des marais sauvages alternent avec des alpages idylliques, surplombés par les sommets de la Schrattenfluh et du Rothorn.</p>",
      weatherData: [28, 155, 11.5, 158, 3, 74, 40],
    },
    {
      id: 7,
      country: 'Grèce',
      commune: 'Genève',
      canton: 'Genève',
      name: 'Héraklion',
      text:
        "<p>La Méditerranée s’invite à Genève, là où la rade, ses voiliers, ses bateaux nous feraient presque penser au port d’Héraklion. Le taux d’humidité et la vitesse du vent sont très proches entre les deux régions. Trois petits degrés séparent leur température maximale respective (28°C pour Héraklion, 25 pour Genève). Pour retrouver un petit air méditerranéen en été, les <a href='https://www.bains-des-paquis.ch/fr/news/sauvons-les-bains' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Bains des Pâquis</a> sont incontournables. On y mange d’ailleurs une excellente salade grecque. La jetée offre une vue imprenable sur la rade. Le phare des Pâquis qui se détache sur le bleu du ciel nous rappelle le bleu de l’océan et le blanc des maisons crétoises. Mais attention, les Bains sont fermés jusqu’à nouvel avis. En espérant leur réouverture prochaine, on admire la jetée et la rade de loin.</p><p> Pour faire un tour sur l’eau, on peut louer un pédalo sur la rive gauche ou la rive droite de la rade, traverser la rade en empruntant les fameuses Mouettes, partir à la pêche avec un <a href='https://genevaboats.com/fr/watersport/fishing/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>pêcheur professionnel</a> ou passer une nuit à bord d’un <a href='https://www.floatinn.swiss' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>voilier ou d’un bateau solaire</a>.</p><p>Une escapade au <a href='http://institutions.ville-geneve.ch/fr/mah/lieux-dexposition/musee-dart-et-dhistoire/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>MAH (Musée d’Art et d’Histoire)</a> vous plongera dans ses collections d’œuvres de la Grèce antique, et, pour parfaire l’illusion méditerranéenne, les restaurants grecs Khora ou Emilios mettront de la fraîcheur dans votre assiette.</p>",
      weatherData: [28, 360, 6.7, 0.5, 2, 58, 21],
    },
    {
      id: 8,
      country: 'Inde',
      commune: 'Grancia',
      canton: 'Tessin',
      name: 'New Dehli',
      text:
        "<p>Tout semble opposer ces deux villes, et pourtant la météo y est étrangement similaire pendant les trois mois d’été. C’est la mousson dans la capitale indienne, où il fait tout de même bien plus chaud qu’au Tessin. Dans la région de Lugano, le visiteur aura plus de facilité à respirer, de la brise sur les rives du lac ou en hauteur depuis le <a href='https://www.myswitzerland.com/fr-ch/decouvrir/monte-bre/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Monte Brè</a>, où on admire toute la région. Le matin avant les grandes chaleurs, on flâne sur les «piazze» du centre piéton. Les jours de marché, les rues fourmillent dans tous les sens, mais rien de comparable avec la foule de New Delhi et ses 20 millions d’habitants.</p><p>Les trois <a href='https://www.myswitzerland.com/fr-ch/decouvrir/plage-lido-di-lugano/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Lido de Lugano</a> permettent de se baigner, de manger et de boire l’apéro <a href='https://www.luganoregion.com/fr/a-voir-et-a-faire/centre-ville-et-promenade/rues-et-places-a-ne-pas-manquer' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>en pleine ville</a>. Croisons les doigts pour qu’ils puissent rouvrir cet été! Inauguré en 1959, le parc <a href='https://www.swissminiatur.ch/swissminiatur/fr/restaurant/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Swissminiatur</a> est un grand classique à Melide. On peut même y manger...indien. Comme on ne quitte pas New Delhi sans avoir dégusté un curry, on ne part du Tessin sans avoir mangé de la polenta locale dans un des «grotti», ces <a href='https://www.luganoregion.com/fr/a-voir-et-a-faire/gastronomie-et-traditions/restaurants-et-grotto' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>auberges rustiques</a> où l’on mange au frais à l’ombre des arbres.</p>",
      weatherData: [36, 200, 12, 167, 3, 60, 216],
    },
    {
      id: 9,
      country: 'Cuba',
      commune: 'Chessel',
      canton: 'Vaud',
      name: 'La Havane',
      text:
        "<p>À La Havane comme à Chessel ou Rennaz, il pleut dix jours par mois en été. L’ensoleillement, l’humidité et la vitesse du vent sont très proches. À Cuba, il souffle un vent chaud. Dans le Chablais vaudois, il s’appelle le fœhn. Acteur constitutif de la région, c’est un vent du sud parfois tempétueux, qui réchauffe et sèche le raisin en automne, ce qui permet d’élaborer des crus chaleureux et puissants, principalement de chasselas. Sur l’île cubaine, le rhum se déguste dans les distilleries. Ici, c’est dans <a href='https://www.myswitzerland.com/fr-ch/decouvrir/decouverte-dune-cave-et-degustation-de-vins/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>les caves</a> que ça se passe, disséminées au cœur des 590 hectares de vignoble.</p><p>Celles et ceux qui auraient voulu voir le Jardin botanique de La Havane trouveront leur bonheur en visitant la réserve naturelle des <a href='https://www.pronatura-grangettes.ch/fr/tour-dobservation' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Grangettes</a>, paradis des oiseaux. Son camping en bord de lac avec une jolie plage permet de se transporter dans une ambiance <a href='https://www.region-du-leman.ch/fr/P16573/camping-les-grangettes' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>presque caribéenne</a>. Et si, à Cuba, il est d’usage de dormir chez l’habitant, pourquoi ne pas faire confiance à l’hospitalité locale et dormir dans un joli établissement Bed & Breakfast de la région?</p><p>Alors que l’entrée de La Havane est protégée par un fort, à Villeneuve, c’est <a href='https://www.lechateaudevilleneuve.ch/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>le chateau</a> qui veille sur la bourgade. Il abrite un restaurant, une excellente adresse pour manger des filets de perche. Les plus jeunes pourront se sentir comme des pirates des Caraïbes accostant sur l’île cubaine à <a href='https://www.aquaparc.ch/parc-attraction-aquatique/activite-aquatique-bateau-pirate' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>Aquaparc</a>, Pour retrouver un peu de Cuba, le <a href='https://www.epiduc.ch/que-faisons-nous/' class='cbLink cB' style='white-space: nowrap;' target='_blank'><i class='icon external-link' style='font-size: 0.8em;' target='_blank'></i>club des cigares</a> les Épicuriens du Chablais proposent des soirées d’initiation pour découvrir l’univers envoûtant des havanes.</p>",
      weatherData: [32, 185, 10, 130, 2, 80, 59],
    },
  ]

  const weatherParametersData = [
    {
      key: 'temperature_max',
      name: 'Température',
      icon: 'thermometer half',
      unit: 'C',
      value: 28,
      max: 45,
      step: 1,
      infos: 'Moyenne de toutes les températures maximales journalières.',
    },
    {
      key: 'sun_duration',
      name: 'Ensoleillement',
      icon: 'sun',
      unit: ' heures',
      value: 360,
      max: 400,
      step: 1,
      infos:
        'Somme de la durée d’ensoleillement mesurée en un lieu donné au cours d’un mois.',
    },
    {
      key: 'rain_days',
      name: 'Jours de pluie',
      icon: 'umbrella',
      unit: ' jours',
      value: 6.7,
      max: 50,
      step: 1,
      infos:
        'Nombre de jours, par mois, où des précipitations supérieures ou égales à 1mm sont mesurées.',
    },
    {
      key: 'rain_mm',
      name: 'Quantité de pluie',
      icon: 'umbrella',
      unit: 'mm',
      value: 0.5,
      max: 300,
      step: 1,
      infos:
        'Somme des précipitations solides et liquides tombées pendant un mois.',
    },
    {
      key: 'wind_speed',
      name: 'Vitesse du vent',
      icon: 'flag',
      unit: 'm/s',
      value: 2,
      max: 10,
      step: 1,
      infos: 'Vitesse moyenne mensuelle du vent',
    },
    {
      key: 'humidity',
      name: 'Humidité',
      icon: 'tint',
      unit: '%',
      value: 58,
      max: 100,
      step: 1,
      infos:
        'Rapport entre l’humidité de l’air moyenne sur un mois et l’humidité maximale possible',
    },
    {
      key: 'altitude',
      name: 'Altitude',
      icon: 'signal',
      unit: 'm',
      value: 21,
      max: 4000,
      step: 1,
      infos: "Moyenne de l'altitude",
    },
  ]

  const [showMap, setShowMap] = useState(false)
  const [customValues, setCustomValues] = useState(false)
  const [selectedDestination, setSelectedDestination] = useState(null)
  const [showWeatherParameterInfos, setShowWeatherParameterInfos] = useState(-1)
  const [weatherParameters, setWeatherParameters] = useState(
    weatherParametersData
  )
  const [weatherParametersLimit, setWeatherParametersLimit] = useState(3)
  const [displayedCommunesLimit, setDisplayedCommunesLimit] = useState(10)
  const [selectedRegion, setSelectedRegion] = useState(0)
  const [filteredCommunes, setFilteredCommunes] = useState(communesTopo)
  const [userDataIn, setUserDataIn] = useState(false)
  const [sliderValues, setSliderValues] = useState([
    28,
    360,
    6.7,
    0.5,
    2,
    58,
    21,
  ])

  const scrollchorRef = useRef(null)

  const filterCommunes = function () {
    console.log('Filter with this weather data:')
    console.log(weatherParameters)
    const communes = { ...communesTopo }

    // Filter by region
    if (selectedRegion !== 0) {
      const features = communes.features.filter(
        (c) => c.properties.KTNR === selectedRegion
      )
      communes.features = features
    }

    // Order by distance
    // 1. Find the maximum value for each parameters
    const maxValues = {}
    weatherParameters.forEach((wp) => {
      const maxCh = d3.max(communes.features, (d) => d.properties[wp.key])
      const max = d3.max([maxCh, wp.value])
      maxValues[wp.key] = max
    })

    // console.log(maxValues)

    // 2. Normalize the parameters of each commune and the target and find the average distance
    const normalizedFeatures = communes.features.map((commune) => {
      let distanceTotal = 0
      for (const p in weatherParameters) {
        const parameter = weatherParameters[p].key
        const normalizedValue =
          commune.properties[parameter] / maxValues[parameter]
        const distance = Math.abs(
          normalizedValue - weatherParameters[p].value / maxValues[parameter]
        )
        commune.properties[parameter + '_distance'] = distance
        distanceTotal += distance
      }
      commune.properties.distance = distanceTotal / weatherParameters.length
      return commune
    })

    communes.features = normalizedFeatures.sort((a, b) =>
      a.properties.distance < b.properties.distance
        ? -1
        : a.properties.distance > b.properties.distance
        ? 1
        : 0
    )
    setUserDataIn(true)
    console.log('Result:')
    console.log(communes)
    return communes
  }

  useEffect(() => {
    console.log('NEW WEATHER PARAMETERS')
    setFilteredCommunes(filterCommunes())
  }, [weatherParameters])

  useEffect(() => {
    console.log('NEW REGION')
    setFilteredCommunes(filterCommunes())
  }, [selectedRegion])

  useEffect(() => {
    // setSelectedDestination(0)
  }, [])

  const destinationName =
    selectedDestination != null ? destinations[selectedDestination].name : null

  console.log(destinationName)

  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header
        style={{backgroundImage: `url(${require('../../images/pic/ch6.jpg')})`}}
        className='ui vertical relaxed segment'>
          <div className='intro-gradient' />
        <div className='ui container'>
          <h1 className='ui image header title'>
            <div className='content title'>
              Dix destinations de rêve sans quitter la Suisse
              <div className='sub header lead'>
              Le Covid-19 remet en question vos projets de départ? Laissez les données climatiques de MétéoSuisse vous guider. Voyagez en Suisse à travers dix destinations exotiques ou recherchez un lieu de vacances en composant votre climat préféré.
              </div>
            </div>
          </h1>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
        <div className='metainfo'>
            <div className='author'>
              <nobr>Mathieu Rudaz</nobr> et <nobr>Fanny Giroud</nobr>
            </div>
          </div>
          <p>
            Le doute est encore possible, mais partir très loin cet été semble
            sérieusement compromis. Il devrait être possible de voyager chez nos
            voisins. Mais pour ceux qui avaient prévu un voyage avec un vrai
            décalage horaire, il faut désormais trouver un plan B: votre vol
            long-courrier pour l’Australie ou le Japon a très peu de chances de
            décoller.
          </p>
          <p>
            Un Suisse sur cinq a prévu de passer ses vacances en Suisse, selon
            un sondage. Mais où aller, que faire? Notre <b className='ftchart'>analyse météo</b> vous
            permettra peut-être de recycler votre projet de voyage original.
            Nous avons comparé le climat de toutes les communes de Suisse avec
            des destinations prisées autour du monde. Température, pluie,
            humidité, ensoleillement, couverture nuageuse: ces paramètres qui
            guident habituellement nos voyages, nous les avons analysés pour
            savoir où partir en Suisse. Un peu d’imagination, quelques heures de
            train, et vous voilà partis pour la <b className='ftchart'>destination de vos rêves</b>.
          </p>
        </div>
      </div>

      <div className='big-segment first' id='destinations-list'>
        {/* <div className='top'>
          <div
            className='layer b'
            style={{
              backgroundImage: `url(${require('./../../images/top-layer-b.svg')})`,
            }}
          />
          <div
            className='layer a'
            style={{
              backgroundImage: `url(${require('./../../images/top-layer-a.svg')})`,
            }}
          />
          </div> */}
        <div className='ui vertical segment'>
          <div className='ui text center aligned container'>
            <h4>
              <div className='sup-header'>Votre destination</div>
              Choisissez une destination
              <div className='sub-header'>
                Nous vous donnerons sa jumelle climatique suisse
              </div>
            </h4>
          </div>
        </div>
        <div>
          <div className='ui center aligned container'>
            <div className='ui very fitted vertical segment'>
              {/* <div className='select-container'>
                <select
                  onChange={(value) => {
                    setSelectedDestination(parseInt(value.target.value))
                    setCustomValues(false)
                  }}
                >
                  <option value="" disabled selected hidden>Votre destination</option>
                  {destinations.map((d, i) => (
                    <option defaultValue={0} key={'option-' + i} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </select>
                <i className='slim down' />
              </div> */}
              <div className='destinations-container'>
                {destinations.map((d, i) => (
                  <div className='destination-card' key={'option-' + i}>
                    <div
                      style={{
                        background: `url(${require('../../images/img-noise-361x370.png')}), linear-gradient(0deg, rgba(255,185,29,1) 0%, rgba(255,211,114,1) 100%)`,
                      }}
                      className='ui fluid card'
                      onClick={() => {
                        const weather = [...weatherParametersData]
                        weather.map((w, i) => {
                          w.value = d.weatherData[i]
                          return w
                        })
                        setWeatherParameters(weather)
                        setSelectedDestination(parseInt(i))
                        setSliderValues(
                          weather.reduce((a, b) => [...a, b.value], [])
                        )
                        setCustomValues(false)
                        window.dataLayer = window.dataLayer || []
                        window.dataLayer.push({
                          event: 'Interactions',
                          event_action: 'click',
                          event_label: 'destination: ' + d.name
                        })
                        scrollchorRef.current.simulateClick()
                      }}
                    >
                      {/* <img src="https://semantic-ui.com/images/avatar/large/daniel.jpg" /> */}
                      <div className='target-image'>
                        <img src={require('../../images/' + d.id + '.jpg')} />
                      </div>
                      <div className='content'>
                        {d.name}
                        <div className='meta'>{d.country}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* <div className='ui-small'>Note sur les destinations</div> */}
              <div className='ui vertical center aligned segment'>
                <Scrollchor to='#target-parameters'>
                  <div className='ui basic small special button right labeled icon'>
                    Ou composez votre propre destination{' '}
                    <i className='chevron down icon' />
                  </div>
                </Scrollchor>
              </div>
            </div>
          </div>
          <Scrollchor ref={scrollchorRef} to='#result' />
        </div>
        <div className='ui big-segment first' id='result'>
          {selectedDestination !== null && (
            <>
              <div className='destination-pic-container'>
                <div
                  className='destination-pic pic-a'
                  style={{
                    backgroundImage: `url(${require('../../images/pic/' +
                      selectedDestination +
                      'a.jpg')})`,
                  }}
                >
                  <h3>
                    <div className='result-commune'>
                      {destinations[selectedDestination].name}
                    </div>{' '}
                    <div className='result-canton'>
                      <nobr>{destinations[selectedDestination].country}</nobr>
                    </div>
                  </h3>
                </div>
                <div
                  className='destination-pic pic-b'
                  style={{
                    backgroundImage: `url(${require('../../images/pic/ch' +
                      selectedDestination +
                      '.jpg')})`,
                  }}
                >
                  <h3>
                    <div className='result-commune'>
                      {destinations[selectedDestination].commune}
                    </div>{' '}
                    <div className='result-canton'>
                      <nobr>{destinations[selectedDestination].canton}</nobr>
                    </div>
                  </h3>
                </div>
                <div className='continue-reading'>
                  <div>Continuez</div>
                  <i className='ui icon arrow down' />
                </div>
              </div>

              <div
                className='ui vertical segment'
                style={{ paddingTop: '3em' }}
              >
                <div className='ui text container'>
                  {/* <div className='result-dest-block-container'>
                      <div className='result-dest-block'>
                        <div className='title'><nobr>
                          {filteredCommunes.features[0].properties.GMDNAME}
                        </nobr></div>
                        <div className='region'>
                      {
                        cantons.find(
                          (c) =>
                            c.id ===
                            filteredCommunes.features[0].properties.KTNR
                        ).name
                      }
                      </div>
                      </div>
                      <div className='result-dest-block'>
                        <div className='title'>
                        {destinationName}
                        </div>
                        <div className='region'>
                        {destinations[selectedDestination].country}
                        </div>
                      </div>
                    </div> */}

                  <div className='ui raised segment'>
                    {/* <div className='ui vertical segment center aligned'>
                      <div
                        className='textres_image tr_left'
                        style={{
                          backgroundImage:
                            'url(' +
                            require('../../images/pic/' +
                              selectedDestination +
                              '.jpg') +
                            ')',
                        }}
                      />
                      <div
                        className='textres_image tr_right'
                        style={{
                          backgroundImage:
                            'url(' +
                            require('../../images/ch' +
                              selectedDestination +
                              '.jpg') +
                            ')',
                        }}
                      />
                    </div> */}

                    <div className='ui vertical segment'>
                      <h3>
                        <b className='special'>
                          {destinations[selectedDestination].commune}
                        </b>{' '}
                        —{' '}
                        <b className='special'>
                          <nobr>{destinationName}</nobr>
                        </b>
                      </h3>
                    </div>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: destinations[selectedDestination].text,
                      }}
                    />
                  </div>
                  <div
                    className='ui vertical center aligned segment'
                    style={{ paddingTop: '1em' }}
                  >
                    <div className='action-link'>
                      <Scrollchor to='#destinations-list'>
                        Cherchez une autre destination
                      </Scrollchor>
                    </div>
                    <Scrollchor to='#target-parameters'>
                      <div className='ui basic small button right labeled icon special'>
                        Ou composez votre propre destination{' '}
                        <i className='chevron down icon' />
                      </div>
                    </Scrollchor>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div id='target-parameters' className='big-segment second'>
        {/* <div className='top'>
          <div
            className='layer b'
            style={{
              backgroundImage: `url(${require('./../../images/top-layer-b.svg')})`,
            }}
          />
          <div
            className='layer a'
            style={{
              backgroundImage: `url(${require('./../../images/top-layer-a.svg')})`,
            }}
          />
          </div> */}
        <div className='ui vertical segment'>
          <div className='ui text center aligned container'>
            <h4>
              <div className='sup-header'>Les données</div>
              {/* customValues ? (
                <>Vos propres moyennes météorologiques</>
              ) : selectedDestination ? (
                <>
                  Voici les moyennes météorologiques pour{' '}
                  <b className='special'>
                    <nobr>{destinationName}</nobr>
                  </b>{' '}
                  durant les mois d'été
                </>
              ) : (
                <>
                  Vous pouvez aussi choisir votre propre climat idéal
                </>
              ) */}
              Composez votre climat
              <div className='sub-header'>
                {destinationName && !customValues
                  ? '(actuellement ' + destinationName + ')'
                  : customValues
                  ? 'Découvrez le résultat plus bas'
                  : '(actuellement Héraklion)'}
              </div>
            </h4>
            {/* !customValues && (
              <div className='ui white icon mini message'>
                <i className='lightbulb icon' />
                <div className='content'>
                  <p>
                    Vous pouvez les changer pour trouver une destination
                    suisse sur mesure.
                  </p>
                </div>
              </div>
            ) */}
          </div>
        </div>
        <div className='ui text container'>
          <div className='ui-message ui raised segment'>
            <div className='ui relaxed divided list'>
              {weatherParameters.map((p, i) => {
                if (i < weatherParametersLimit) {
                  return (
                    <div className='item' key={'target-weather-parameter-' + i}>
                      <i className={`large ${p.icon} middle aligned icon`} />
                      <div className='content'>
                        <div style={{ marginBottom: '0.5em' }}>
                          {p.name}{' '}
                          <i
                            className='question circle icon'
                            onClick={() => {
                              setShowWeatherParameterInfos(
                                showWeatherParameterInfos !== i ? i : -1
                              )
                            }}
                          />
                          {i === showWeatherParameterInfos && (
                            <div className='ui-small'>{p.infos}</div>
                          )}
                        </div>
                        <b className='special'>
                          {sliderValues[i]}
                          <span style={{ fontWeight: 'normal' }}>{p.unit}</span>
                        </b>
                        <Slider
                          onAfterChange={(value) => {
                            const newWeatherParameters = [...weatherParameters]
                            newWeatherParameters[i].value = value
                            setWeatherParameters(newWeatherParameters)
                          }}
                          onChange={(value) => {
                            const newSliderValues = [...sliderValues]
                            newSliderValues[i] = value
                            setSliderValues(newSliderValues)
                            setCustomValues(true)
                          }}
                          min={p.min}
                          max={p.max}
                          value={sliderValues[i]}
                          // defaultValue={weatherParameters[i].value}
                        />
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          </div>
          <div
            className='ui center aligned vertical segment'
            style={{ paddingTop: '1em' }}
          >
            <div
              className='ui basic small button right labeled icon'
              onClick={() => {
                setWeatherParametersLimit(weatherParametersLimit === 3 ? 10 : 3)
              }}
            >
              En afficher {weatherParametersLimit > 3 ? 'moins' : 'davantage'}
              <i
                className={`chevron ${
                  weatherParametersLimit > 3 ? 'up' : 'down'
                } icon`}
              />
            </div>
            <div className='action-link' style={{ paddingTop: '1em' }}>
              <Scrollchor to='#result-communes-list'>
                Continuez à scroller pour découvrir les communes les semblables
              </Scrollchor>
            </div>
          </div>
        </div>
      </div>

      {userDataIn && (
        <div
          className='big-segment second'
          style={{ paddingBottom: '20px' }}
          id='result-communes-list'
        >
          {/* <div className='top'>
            <div
              className='layer b'
              style={{
                backgroundImage: `url(${require('./../../images/top-layer-b.svg')})`,
              }}
            />
            <div
              className='layer a'
              style={{
                backgroundImage: `url(${require('./../../images/top-layer-a.svg')})`,
              }}
            />
            </div> */}

          <div className='ui vertical segment'>
            <div className='ui text center aligned container'>
              <h4>
                <div className='sup-header'>Résultat</div>
                Voici les communes qui correspondent à vos critères
              </h4>
              <div
                className='ui small basic button'
                onClick={() => {
                  setShowMap(!showMap)
                }}
              >
                <i className={`icon ${showMap ? 'list' : 'map'}`} /> Afficher la{' '}
                {showMap ? 'liste' : 'carte'}
              </div>
              <div className='select-container'>
                <select
                  onChange={(value) => {
                    const regionId = +value.target.value
                    setSelectedRegion(regionId)
                  }}
                >
                  {cantons.map((d, i) => {
                    return (
                      <>
                        {i === 1 && <option disabled>──────────</option>}
                        <option
                          defaultValue={0}
                          key={'option-' + i}
                          value={d.id}
                        >
                          {d.name}
                        </option>
                      </>
                    )
                  })}
                </select>
                <i className='slim down' />
              </div>
            </div>
            <div
              className='ui vertical segment'
              style={{ paddingBottom: '0px' }}
            >
              <div className='ui-message'>
                {showMap ? (
                  <div className='ui container'>
                    <Map filteredCommunes={filteredCommunes} />
                  </div>
                ) : (
                  <div className='ui text container'>
                    <div className='ui raised segment communes-result-list'>
                      <div className='ui middle aligned divided list'>
                        <div
                          className='item'
                          style={{ fontWeight: '800', fontSize: '0.75em' }}
                        >
                          <div className='right floated content'>
                            Similarité
                          </div>
                          <div className='content'>Communes</div>
                        </div>
                        {filteredCommunes.features.map(
                          (c: ExtendedFeature, i: number) => {
                            if (i < displayedCommunesLimit) {
                              const projection = d3
                                .geoMercator()
                                .fitSize([100, 100], c)
                              const path = d3.geoPath().projection(projection)

                              return (
                                <div
                                  className='item'
                                  key={'commune-result-' + i}
                                >
                                  <div className='right floated content'>
                                    {Math.round(
                                      (1 - c.properties.distance) * 10000
                                    ) / 100}
                                    %
                                  </div>
                                  <svg
                                    className='commune'
                                    viewBox={'0 0 ' + 100 + ' ' + 100}
                                  >
                                    <g className='topology'>
                                      <path d={path(c)} />
                                    </g>
                                  </svg>
                                  <div className='content'>
                                    <div>
                                      <b>{c.properties.GMDNAME}</b>
                                    </div>
                                    <div className='meta'>
                                      {
                                        cantons.find(
                                          (canton) =>
                                            canton.id === c.properties.KTNR
                                        ).name
                                      }
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          }
                        )}
                      </div>
                    </div>
                    <div
                      className='ui center aligned vertical segment'
                      style={{ paddingBottom: '0px' }}
                    >
                      <div
                        className='ui basic small button right labeled icon'
                        onClick={() => {
                          setDisplayedCommunesLimit(displayedCommunesLimit + 10)
                        }}
                      >
                        En afficher davantage{' '}
                        <i className='chevron down icon' />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <div className='ui vertical center aligned segment'>
        <Scrollchor to='#target-parameters'>
          <div
            className='ui basic small button right labeled icon'
            onClick={() => {
              setDisplayedCommunesLimit(0)
            }}
          >
            Essayez avec d'autres valeurs <i className='chevron up icon' />
          </div>
        </Scrollchor>
          </div> */}

      <div className='ui vertical grey segment' id='methode'>
        <div className='big-segment neutral'>
          <div className='ui text left aligned container'>
            <h4>Pourquoi ce classement?</h4>
            <p>
              Les similarités entre les paramètres climatiques sont calculées
              individuellement. Puis leur moyenne donne la ressemblance entre
              chaque commune suisse et les caractéristiques des destinations que
              nous vous proposons. Si vous avez choisi vos propres paramètres
              climatiques, ce sont ces chiffres qui sont comparés aux données de
              chaque commune. Tous les chiffres suisses sont pris sur la{' '}
              <b>moyenne</b> de l'<b>ensemble du territoire</b> des communes.
            </p>
            <p>
              Voici par exemple les données individuelles de la commune la plus
              proche et la plus éloignée des valeurs climatiques choisies avec,
              pour chacune d'elles, leur score de similarité.
            </p>
          </div>
          <div className='ui vertical segment'>
            <div className='ui container'>
              <div className='ui stackable two column grid'>
                <div className='column'>
                  <h3>
                    <div className='sup-header'>La plus semblable</div>
                    <b>{filteredCommunes.features[0].properties.GMDNAME}</b> (
                    {Math.round(
                      (1 - filteredCommunes.features[0].properties.distance) *
                        10000
                    ) / 100}
                    %)
                  </h3>
                  <table
                    className='ui celled table'
                    style={{ fontSize: '0.85em' }}
                  >
                    <thead>
                      <tr>
                        <th>Paramètre</th>
                        <th>Valeur</th>
                        <th>Similarité</th>
                      </tr>
                    </thead>
                    <tbody>
                      {weatherParameters.map((p, i) => (
                        <tr key={'tra-' + i}>
                          <td>
                            <i className={`${p.icon} middle aligned icon`} />
                            {p.name}
                          </td>
                          <td>
                            <b>
                              {Math.round(
                                filteredCommunes.features[0].properties[p.key]
                              )}
                            </b>
                            {weatherParameters[i].unit}
                          </td>
                          <td>
                            <b>
                              {Math.round(
                                (1 -
                                  filteredCommunes.features[0].properties[
                                    p.key + '_distance'
                                  ]) *
                                  10000
                              ) / 100}
                              %
                            </b>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className='column'>
                  <h3>
                    <div className='sup-header'>La moins semblable</div>
                    <b>
                      {
                        filteredCommunes.features[
                          filteredCommunes.features.length - 1
                        ].properties.GMDNAME
                      }
                    </b>{' '}
                    (
                    {Math.round(
                      (1 -
                        filteredCommunes.features[
                          filteredCommunes.features.length - 1
                        ].properties.distance) *
                        10000
                    ) / 100}
                    %)
                  </h3>
                  <table
                    className='ui celled table'
                    style={{ fontSize: '0.85em' }}
                  >
                    <thead>
                      <tr>
                        <th>Paramètre</th>
                        <th>Valeur</th>
                        <th>Similarité</th>
                      </tr>
                    </thead>
                    <tbody>
                      {weatherParameters.map((p, i) => (
                        <tr key={'tra-' + i}>
                          <td>
                            <i className={`${p.icon} middle aligned icon`} />
                            {p.name}
                          </td>
                          <td>
                            <b>
                              {Math.round(
                                filteredCommunes.features[
                                  filteredCommunes.features.length - 1
                                ].properties[p.key]
                              )}
                            </b>
                            {weatherParameters[i].unit}
                          </td>
                          <td>
                            <b>
                              {Math.round(
                                (1 -
                                  filteredCommunes.features[
                                    filteredCommunes.features.length - 1
                                  ].properties[p.key + '_distance']) *
                                  10000
                              ) / 100}
                              %
                            </b>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='big-segment neutral'>
          <div
            className='ui text container methode'
            style={{ position: 'relative' }}
          >
            <div className='innerWrapperMethodik'>
              <h4>Méthodologie</h4>
              <p>
                Les données météorologiques des communes proviennent des{' '}
                <Link href='https://www.meteosuisse.admin.ch/home/climat/le-climat-suisse-en-detail/normes-climatologiques/normes-par-parametre.html'>
                  normes climatologiques
                </Link>{' '}
                de MétéoSuisse. Nous avons fait la moyenne de l'historique de
                ces valeurs pour les mois de juin, juillet et août.
              </p>
              <p>
                Chaque commune n'ayant pas sa propre station de mesure, nous
                avons dû interpoler les valeurs entre les stations pour couvrir
                tout le territoire. Il se peut donc que des écarts existent
                entre les données interpolées et les données réelles.
              </p>

              <p>
                Les paramètres climatiques des destinations de l'étranger
                proviennent du site{' '}
                <Link href='https://weather-and-climate.com/'>
                  weather-and-climate.com
                </Link>
                . Si l'une ou l'autre des données climatiques était introuvable
                depuis cette source, nous avons alors complété les mesures
                depuis{' '}
                <Link href='https://www.timeanddate.com/weather/'>
                  timeanddate.com
                </Link>
                .
              </p>

              <p>
                En fonction des données suisses et mondiales disponibles, nous
                avons choisi de comparer les paramètres suivants:
              </p>

              <ul>
                <li>
                  <b>Température maximale</b>
                  <p>
                    Moyenne de toutes les températures maximales journalières
                    d’un mois
                  </p>
                </li>
                <li>
                  <b>Heures d'ensoleillement par mois</b>
                  <p>
                    Somme de la durée d’ensoleillement mesurée en un lieu donné
                    au cours d’un mois.
                  </p>{' '}
                </li>
                <li>
                  <b>Jours avec précipitations</b>
                  <p>
                    Nombre de jours, par mois, où des précipitations supérieures
                    ou égales à 1 mm sont mesurées.
                  </p>{' '}
                </li>
                <li>
                  <b>Somme des précipitations</b>
                  <p>
                    Somme des précipitations solides et liquides tombées pendant
                    un mois.
                  </p>{' '}
                </li>
                <li>
                  <b>Vitesse du vent</b>
                  <p>Vitesse moyenne mensuelle du vent à un endroit</p>{' '}
                </li>
                <li>
                  <b>Humidité relative de l’air</b>
                  <p>
                    Rapport entre l’humidité de l’air moyenne sur un mois et
                    l’humidité maximale possible
                  </p>{' '}
                </li>
                <li>
                  <b>Altitude</b>
                  <p>
                    Moyenne de l'altitude dans chaque commune et altitude
                    "officielle" des destinations à l'étranger
                  </p>{' '}
                </li>
              </ul>

              <p>
                Bien sûr, des variations importantes peuvent survenir d'une
                année à l'autre et nous nous fondons sur les moyennes des mois
                d'été uniquement, pour la Suisse comme pour l'étranger.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer
        title='Comment jugez-vous ce contenu?'
        mailTo='mathieu.rudaz@24heures.ch'
        locale='fr'
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        credits={[
          ['Textes', 'Fanny Giroud'],
          ['Conception', 'Mathieu Rudaz'],
          [
            'Sources',
            'MétéoSuisse, Suisse Tourisme, weather-and-climate.com, timeanddate.com',
          ],
        ]}
      />
    </div>
  )
}
